import { API, APIResultList } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type AssetMetaUpdate = {
  uuid: string;
  meta: {
    name?: string;
    background_color?: string;
  };
};

const [useBatchUpdateAssetsMetadata, batchUpdateAssetsMetadata] = createAsyncAction(
  "assets/batchUpdateAssetsMetadata",
  async (updatedAssetsMeta: AssetMetaUpdate[]) => {
    const res = await API.call<APIResultList<"assets", string>>({
      endpoint: `sync/assets`,
      method: "POST",
      data: {
        assets: updatedAssetsMeta,
      },
    });
    return { ...res, result: res.result.assets };
  }
);

export default useBatchUpdateAssetsMetadata;
export { batchUpdateAssetsMetadata };
